var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.394,
    height: 19.422,
    viewBox: "0 0 23.394 19.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4855",
    "data-name": "Rectangle 4855",
    width: 23.394,
    height: 19.422,
    transform: "translate(0 0)",
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10138",
    "data-name": "Group 10138",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10137",
    "data-name": "Group 10137",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5704",
    "data-name": "Path 5704",
    d: "M19.642,12.568c-1.407.035-1.867-.859-2.4-1-.577-.151-1.344.924-2.909.417A2.48,2.48,0,0,1,12.851,8.91c.227-1.076,1.04-1.454,1.952-1.839a1.157,1.157,0,0,0,.589-.494c.6-1,1.132-1.755,2.441-1.63a2.008,2.008,0,0,1,1.674,1.1l.423,1.032a1.14,1.14,0,0,0,.432.547c.813.556,1.548,1.092,1.565,2.181a2.457,2.457,0,0,1-2.285,2.762",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5705",
    "data-name": "Path 5705",
    d: "M8.929,18.879c-1.815.48-2.33-1.035-3.234-.206a2.646,2.646,0,0,1-2.727.592,2.607,2.607,0,0,1-1.5-2.587c.007-1.072.709-1.623,1.526-2.171a1.214,1.214,0,0,0,.51-.668c.369-1.115.821-1.94,2.1-2.044a1.929,1.929,0,0,1,1.847.8l.578.873a1.081,1.081,0,0,0,.509.427c.922.391,1.764.76,2,1.844a2.462,2.462,0,0,1-1.607,3.136",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5706",
    "data-name": "Path 5706",
    d: "M19.7,4.515a1.263,1.263,0,0,1-1.148-.748C17.827,2.33,18.63.335,19.877.334a1.265,1.265,0,0,1,1.109.733c.727,1.4-.021,3.409-1.283,3.448",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5707",
    "data-name": "Path 5707",
    d: "M3.957,11.341a1.286,1.286,0,0,1-1.3-.548,2.775,2.775,0,0,1-.277-2.829A1.252,1.252,0,0,1,3.65,7.2a1.446,1.446,0,0,1,1.014.685c.836,1.283.452,3.208-.707,3.461",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5708",
    "data-name": "Path 5708",
    d: "M8.392,8.675c.141,1.021-.261,2.2-1.172,2.341a1.2,1.2,0,0,1-1.035-.333,2.706,2.706,0,0,1-.374-3.245,1.265,1.265,0,0,1,.834-.57c.928-.148,1.609.8,1.747,1.807",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5709",
    "data-name": "Path 5709",
    d: "M16.35,4.177a1.256,1.256,0,0,1-1.091-.72A2.739,2.739,0,0,1,15.575.5,1.216,1.216,0,0,1,17.054.116c1.04.515,1.184,2.332.418,3.421a1.361,1.361,0,0,1-1.122.64",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5710",
    "data-name": "Path 5710",
    d: "M22.662,7.243a1.135,1.135,0,0,1-1.717-.162,2.561,2.561,0,0,1,.27-3.148,1.138,1.138,0,0,1,1.8.173,2.565,2.565,0,0,1-.35,3.137",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5711",
    "data-name": "Path 5711",
    d: "M1.536,14.41C.328,14.42-.455,12.467.292,11.09a1.229,1.229,0,0,1,.911-.657,1.219,1.219,0,0,1,1.086.467A2.607,2.607,0,0,1,2.6,13.7a1.208,1.208,0,0,1-1.059.706",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5712",
    "data-name": "Path 5712",
    d: "M10.164,13.5a1.152,1.152,0,0,1-1.221-.314,2.55,2.55,0,0,1-.214-3.174,1.113,1.113,0,0,1,1.5-.248,2.513,2.513,0,0,1,.754,2.84,1.426,1.426,0,0,1-.822.9",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5713",
    "data-name": "Path 5713",
    d: "M13.576,6.711a1.237,1.237,0,0,1-1.087-.776A2.62,2.62,0,0,1,12.827,3.2a1.184,1.184,0,0,1,1.347-.4,1.4,1.4,0,0,1,.773.838c.52,1.357-.211,3.086-1.371,3.073",
    fill: "#d13c3c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.50e2eefa7cdc71c61c38bd542e97ec90.svg";
export { ForwardRef as ReactComponent };